// function component:

import React, { useState, useEffect } from 'react';
import { ToastContainer, Toast, Button } from 'react-bootstrap';
import axios from 'axios';

let refreshInterval: NodeJS.Timeout;

declare let APP_COMMITHASH: string;

const NewAppVersionAlert = () => {
    const [currentVersion, setCurrentVersion] = useState<string | null>(null);
    const [latestVersion, setLatestVersion] = useState<string | null>(null);

    useEffect(() => {
        const fetchCurrentVersion = async () => {
            setCurrentVersion(APP_COMMITHASH);
        };
        fetchCurrentVersion();
    }, []);

    useEffect(() => {
        refreshInterval = setInterval(() => {
            const fetchLatestVersion = async () => {
                const response = await axios.get(`${process.env.APP_URL}/static/version.json`, {
                    headers: {
                        'Cache-Control': 'no-cache',
                    },
                });
                setLatestVersion(response.data.version);
            };
            fetchLatestVersion();
        }, 180000);
        return () => {
            clearInterval(refreshInterval);
        };
    }, [latestVersion]);

    const onClose = () => {
        setLatestVersion(null);
        clearInterval(refreshInterval);
    };

    return (
        <ToastContainer
            position="top-end"
            className="p-3 position-fixed mb-4 mt-5"
        >
            {
                currentVersion && latestVersion && currentVersion !== latestVersion && (
                    <Toast
                        onClose={onClose}
                    >
                        <Toast.Header
                            closeButton
                        >
                            <strong className="me-auto">New version available!</strong>
                        </Toast.Header>
                        <Toast.Body
                            className="d-flex"
                        >
                            <Button
                                onClick={() => { window.location.reload(); }}
                                className="m-auto"
                            >
                                Refresh page
                            </Button>
                        </Toast.Body>
                    </Toast>
                )
            }
        </ToastContainer>
    );
};

export default NewAppVersionAlert;
